import React from 'react';

import { useApp } from '../../store/AppContext';
import TimelineLine from './TimelineLine';

/* Infobulle d'une barre, qui suit la souris. */
export default function TimelineTooltip() {
  const { timelineHover } = useApp();
  if (!timelineHover) return null;
  return (
    <div
      className="fixed z-[60] bg-white shadow-[0_6px_20px_rgba(2,56,72,0.16)] py-[9px] px-[11px] pointer-events-none min-w-[170px] max-w-[230px] [border:1px_solid_#e5e3de] rounded-[8px]"
      style={{
        left: Math.min(timelineHover.x + 14, window.innerWidth - 240),
        top: timelineHover.y + 16,
      }}
    >
      {timelineHover.lines.map((ln, i) => (
        <TimelineLine key={i} ln={ln} i={i} />
      ))}
    </div>
  );
}
